module.exports = __webpack_public_path__ + "static/total-control@2x-c8dc5064438988aae9b0973f9d584c65.png";